import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class Nptl extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Digital Library" image="banner/library-3.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">NPTEL</h4>
                    </div>
                    <p className="justify">About Us NPTEL (National Programme on Technology Enhanced Learning), is a joint venture of the IITs and IISc, funded by the Ministry of Education (MoE) Government of India, and was launched in 2003. Initially started as a project to take quality education to all corners of the country, NPTEL now offers close to 600+ courses for certification every semester in about 22 disciplines.</p><br />
                    <ul className="ttm-list ttm-list-style-icon paddingtop-2">
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>Largest online repository in the world of courses in engineering, basic sciences and selected humanities and management subjects</li>
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>YouTube channel for NPTEL – most subscribed educational channel, 1.3 billion views and 40+ lakhs subscribers</li>
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>More than 56000 hours of video content, transcribed and subtitled</li>
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>Most accessed library of peer-reviewed educational content in the world</li>
                      <li><i className="fa fa-check-circle ttm-textcolor-skincolor"></i>Translation of more than 12000 hrs of English transcripts in regional Indian languages</li>
                    </ul>
                  </div>
                </div>
                <div className="ttm-service-single-content-area paddingtop-2">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">Links</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead style={{ backgroundColor: "#98002e", color: "white" }}>
                      <tr>
                        <th scope="col">SL No</th>
                        <th scope="col">Name</th>
                        <th scope="col">URL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>NPTEL</td>
                        <td><a href="http://nptel.ac.in/" target="_blank">Click Here</a></td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>Local Guru</td>
                        <td><a href="http://119.161.98.143/localguru/" target="_blank">Click Here</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DigitalSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
